<template>
  <div class="contain">
    <h2>{{ header }}</h2>
    <p>{{ body }}</p>
    <CardActions>
      <Button @click="hideModal" :label="label" />
    </CardActions>
  </div>
</template>

<script>
import { hideModal } from '@/store'
import { Button, CardActions } from '@neurotrack/web-shared-components'
import { mapMutations } from 'vuex'

export default {
  name: 'Generic',
  components: { Button, CardActions },
  methods: {
    ...mapMutations([hideModal])
  },
  props: {
    body: {
      type: String,
      default: ''
    },
    header: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped>
p {
  text-align: center;
  margin-top: 0;
}
.contain {
  display: flex;
  flex-direction: column;
  align-items: center;
}
</style>
